import {Component, computed, input} from '@angular/core';
import {AppNumberPipe} from '@frontend/shared';
import {CARE_RATIO_BENCHMARK} from '../benchmark.data';

const AXIS_START = 24;
const AXIS_END = 376;

@Component({
  selector: 'app-benchmark-ray',
  imports: [AppNumberPipe],
  templateUrl: './benchmark-ray.component.html',
  styleUrl: './benchmark-ray.component.scss',
})
export class BenchmarkRayComponent {
  readonly ratio = input.required<number>();

  protected readonly benchmark = CARE_RATIO_BENCHMARK;
  protected readonly axisStart = AXIS_START;
  protected readonly axisEnd = AXIS_END;

  protected readonly typicalStart = computed(() => this.toAxisX(this.benchmark.typicalMin));
  protected readonly typicalEnd = computed(() => this.toAxisX(this.benchmark.typicalMax));
  protected readonly typicalWidth = computed(() => this.typicalEnd() - this.typicalStart());
  protected readonly markerX = computed(() => this.toAxisX(this.ratio()));

  private toAxisX(value: number): number {
    const {scaleMin, scaleMax} = this.benchmark;
    const clamped = Math.min(Math.max(value, scaleMin), scaleMax);
    return AXIS_START + ((clamped - scaleMin) / (scaleMax - scaleMin)) * (AXIS_END - AXIS_START);
  }
}
